import { lazy } from 'react';

import type { TabKenh } from '../channels/tabRegistry.js';

/**
 * Mục "Đồng bộ" trong tab "Cài đặt kênh" (order 40 theo bản đồ phụ thuộc).
 *
 * Kết nối Google là một **cài đặt** của kênh, không phải một mặt dữ liệu: nó
 * nằm cùng chỗ với hồ sơ và phân công, không còn là tab riêng.
 */
const channelTabs: TabKenh[] = [
  {
    id: 'dong-bo',
    nhom: 'cai-dat',
    label: 'Kết nối YouTube',
    order: 40,
    permission: { module: 'sync', level: 'view' },
    component: lazy(() => import('./components/TabDongBo.js')),
  },
];

export default channelTabs;
